<template>
  <footer class="footer">
    <b-container>
      <b-row no-gutters>
        <b-col>
          <div align="left" class="footer-text-container">
            <span class="footer-text"><i class="far fa-copyright"></i> {{ this.currentYear }} Ticca Oy | wigr@ticca.fi</span>
          </div>
          <div align="left" class="footer-text-container">
            <span class="footer-text"><a style="color:#CFD0D1;" href="https://twitter.com/wigrofficial"><i style="color:#1DA1F2;" class="fab fa-twitter"></i> Twitter</a> | <a style="color:#CFD0D1;" href="https://facebook.com/wigrofficial"><i style="color:#3b5998;" class="fab fa-facebook"></i> Facebook</a></span>
          </div>
        </b-col>
        <b-col>
          <a class="dont-show" href="http://www.ticca.fi">
            <img class="footer-logo" src="../assets/ticca_logo_png.png" />
          </a>
          <div>
          <div align="right" class="footer-text-container">
            <b-link href="/terms&conditions">
              <span class="footer-text"> Terms & conditions</span>
            </b-link>
            <span style="color:#CFD0D1;"> | </span>
            <b-link href="/privacy_policy">
              <span class="footer-text">Privacy policy</span>
            </b-link>
          </div>
          </div>
          <div align="right" class="footer-text-container">
            <b-link href="/about">
              <span class="footer-text">About us</span>
            </b-link>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'custom-footer',
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style>
.footer {
  position: relative;
  bottom: 0;
  width: 100%;
  height: 5rem;
  line-height: 3rem;
  background-color: #2f2f2fff;
}

.footer-text {
  color: #cfd0d1;
}

.footer-text-container {
  height: 1.5rem;
}

.footer-logo {
  width: 8rem;
  float: right;
  margin-top: 30px;
}

.dont-show {
  display: none;
}

.pp {
  background-color: #1e252c;
  color: #cfd0d1;
  height: 80vh;
  width: 80vw;
  position: fixed;
  left: 10%;
  top: 10%;
  margin: auto;
}

@media (max-width: 768px) {
  .footer-text {
    font-size: 0.8rem;
  }
  .footer {
    height: 3rem;
    line-height: 2rem;
  }
}

@media (max-width: 482px) {
  .footer-text {
    font-size: 0.6rem;
  }
  .footer {
    height: 2rem;
    line-height: 1.5rem;
  }
}

@media (max-width: 395px) {
  .footer-text {
    font-size: 0.4rem;
  }
}
</style>
